import React from 'react';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import './App.css';
import Header from './components/Header';
import Hero from './components/Hero';
import CtaCards from './components/CtaCards';
import Partners from './components/Partners';
import ConsumerApp from './components/ConsumerApp';
import Products from './components/Products';
import WhyChooseUs from './components/WhyChooseUs';
import Reviews from './components/Reviews';
import ContactSection from './components/ContactSection';
import ExpertWidget from './components/ExpertWidget';
import Footer from './components/Footer';
import InsurancePage from './pages/InsurancePage';
import OtherProductPage from './pages/OtherProductPage';
import { Toaster } from './components/ui/toaster';
import { useSeo } from './lib/useSeo';

const ScrollToTop = () => {
  const { pathname, hash } = useLocation();
  React.useEffect(() => {
    if (hash) {
      const el = document.querySelector(hash);
      if (el) { el.scrollIntoView({ behavior: 'smooth' }); return; }
    }
    window.scrollTo({ top: 0, behavior: 'instant' });
  }, [pathname, hash]);
  return null;
};

const Home = () => {
  useSeo({
    title: 'InsureRiskFree Solutions | Buy insurance online in India with expert advisory',
    description:
      'Compare and buy insurance online in India with expert advisory for health, car, bike, life, term, and travel insurance. Get fast quotes, easy renewals, and trusted policy support.',
    canonical: 'https://insureriskfree.com/',
    url: 'https://insureriskfree.com/',
    ogImage: 'https://insureriskfree.com/og-image.jpg',
    twitterImage: 'https://insureriskfree.com/og-image.jpg',
    keywords:
      'insurance comparison India, buy insurance online, car insurance, health insurance, bike insurance, life insurance, term insurance, travel insurance, insurance renewal, insurance advisor',
  });

  return (
    <>
      <Hero />
      <CtaCards />
      <Partners />
      <Products />
      <WhyChooseUs />
      <Reviews />
      <ContactSection />
    </>
  );
};

const Layout = ({ children }) => (
  <>
    <Header />
    <main>{children}</main>
    <Footer />
    <ExpertWidget />
    <Toaster />
  </>
);

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <ScrollToTop />
        <Layout>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/insurance/:slug" element={<InsurancePage />} />
            <Route path="/products/:slug" element={<OtherProductPage />} />
          </Routes>
        </Layout>
      </BrowserRouter>
    </div>
  );
}

export default App;
